// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1n-o";
export var animationRelative = "_1n-n";
export var backdropBlur = "_1n-0";
export var detailLabelCell = "_1n-10";
export var detailTable = "_1n-z";
export var detailValueCell = "_1n-11";
export var docIconBox = "_1n-19";
export var docTypeRow = "_1n-14";
export var docTypeRowInner = "_1n-15";
export var dropdownMatchDatePicker = "_1n-1";
export var fileUploadSpin = "_1n-h";
export var gorgiasOpenButton = "_1n-13 _1n-b";
export var gorgiasTicketCard = "_1n-12";
export var heroModalFooterButton = "_1n-16";
export var hiddenContainer = "_1n-m";
export var maxWidthContainer = "_1n-17";
export var modalContentBody = "_1n-8";
export var modalHeaderImage = "_1n-3";
export var modalImageLabel = "_1n-5";
export var modalImageOverlay = "_1n-4";
export var modalImageSubtitle = "_1n-7";
export var modalImageTitle = "_1n-6";
export var modalImageWrapper = "_1n-2";
export var modalStickyFooter = "_1n-9";
export var removeButton = "_1n-c";
export var sidebarColumn = "_1n-18";
export var spinner = "_1n-g";
export var timelineLine = "_1n-w";
export var timelineLineBlack = "_1n-y _1n-w";
export var timelineLineGray = "_1n-x _1n-w";
export var timelineLineHeight = "_1n-v";
export var tlDotActivate = "_1n-s";
export var tlDotActivateAnim = "_1n-r";
export var tlDotHide = "_1n-q";
export var tlDotHideAnim = "_1n-p";
export var tlLineActivate = "_1n-u";
export var tlLineActivateAnim = "_1n-t";
export var uploadHint = "_1n-l";
export var uploadIconBox = "_1n-i";
export var uploadLabel = "_1n-k";
export var uploadText = "_1n-j";
export var uploadZone = "_1n-d";
export var uploadZoneCursorDefault = "_1n-f";
export var uploadZoneCursorPointer = "_1n-e";
export var uploadedFileRow = "_1n-a";
export var viewButton = "_1n-b";